'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MPPSubnav = require('./MPPSubnav');

var _MPPSubnav2 = _interopRequireDefault(_MPPSubnav);

var _MPPMainMenu = require('./../components/MPPMainMenu');

var _MPPMainMenu2 = _interopRequireDefault(_MPPMainMenu);

var _Button = require('../../../../atoms/button/jsx/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainMenuCustom = function (_MainMenu) {
  _inherits(MainMenuCustom, _MainMenu);

  function MainMenuCustom() {
    _classCallCheck(this, MainMenuCustom);

    return _possibleConstructorReturn(this, (MainMenuCustom.__proto__ || Object.getPrototypeOf(MainMenuCustom)).apply(this, arguments));
  }

  _createClass(MainMenuCustom, [{
    key: 'renderByStrategies',
    value: function renderByStrategies(elem, idx, handlers) {
      var _props = this.props,
          register = _props.register,
          activeLinkIndex = _props.activeLinkIndex,
          closingLinkIndex = _props.closingLinkIndex,
          content = _props.content;
      var minimalHeader = content.minimalHeader;


      var strategies = {
        link: function link(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'sublist-link' + idx },
            _react2.default.createElement(
              'a',
              {
                href: elementContent.href,
                className: 'sublist-link',
                'data-pa-click': 'HeaderSublist-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        cta: function cta(elementContent) {
          return _react2.default.createElement(
            'li',
            { className: 'sublist-cta-wrapper', key: 'sublist-link' + idx },
            _react2.default.createElement(
              _Button2.default,
              {
                href: elementContent.href,
                className: 'sublist-cta',
                color: 'outline-white',
                fpti: 'HeaderMainMenu-Cta-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        linkOnly: function linkOnly(elementContent) {
          var highlighClassName = '';
          if (typeof window !== 'undefined') {
            var currentLocation = window.location.pathname;
            if (currentLocation.indexOf(elementContent.href) !== -1) {
              highlighClassName = 'pypl-header__subnav-control--is-highlighted';
            }
          }
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link ' + highlighClassName,
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        languageDesk: function languageDesk(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx, className: 'hidden-lg-down' },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link separator-menu',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        languageMobile: function languageMobile(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx, className: 'hidden-xl-up' },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        linkOnlyDesk: function linkOnlyDesk(elementContent) {
          return _react2.default.createElement(
            'li',
            { className: 'hidden-lg-down', key: 'main-link' + idx },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        subnav: function subnav(elementContent) {
          return _react2.default.createElement(_MPPSubnav2.default, {
            key: 'main-link' + idx,
            content: elementContent,
            handlers: handlers,
            minimalHeader: minimalHeader,
            register: register,
            activeLinkIndex: activeLinkIndex,
            closingLinkIndex: closingLinkIndex
          });
        },
        subnavGrouped: function subnavGrouped(elementContent) {
          return _react2.default.createElement(_MPPSubnav2.default, {
            key: 'main-link' + idx,
            content: elementContent,
            handlers: handlers,
            minimalHeader: minimalHeader,
            register: register,
            activeLinkIndex: activeLinkIndex,
            closingLinkIndex: closingLinkIndex,
            grouped: true
          });
        }
      };
      return strategies[elem.type](elem);
    }
  }]);

  return MainMenuCustom;
}(_MPPMainMenu2.default);

exports.default = MainMenuCustom;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v3/MPPMainMenu.js
// module id = 1100
// module chunks = 4